var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.05391 15.1526C2.58162 15.1526 2.17917 14.9863 1.84656 14.6536C1.51396 14.321 1.34766 13.9186 1.34766 13.4463V4.55392C1.34766 4.08164 1.51397 3.67919 1.84659 3.34658C2.17919 3.01396 2.58164 2.84766 3.05392 2.84766H14.9463C15.4186 2.84766 15.821 3.01396 16.1536 3.34658C16.4863 3.67919 16.6526 4.08164 16.6526 4.55392V13.4463C16.6526 13.9186 16.4863 14.321 16.1536 14.6536C15.821 14.9863 15.4186 15.1526 14.9463 15.1526H3.05391ZM9.00009 9.94292L3.05391 6.19292V13.4463H14.9463V6.19292L9.00009 9.94292ZM9.00009 8.30392L14.9463 4.55392H3.05391L9.00009 8.30392ZM3.05391 6.19292V4.55392V13.4463V6.19292Z",
    fill: "#909092"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.c7905acb74fbc0765c201891dcc150b4.svg";
export { ForwardRef as ReactComponent };